import { render } from "./ContextHistoryView.vue?vue&type=template&id=007fc53e&scoped=true"
import script from "./ContextHistoryView.vue?vue&type=script&lang=js"
export * from "./ContextHistoryView.vue?vue&type=script&lang=js"

import "./ContextHistoryView.vue?vue&type=style&index=0&id=007fc53e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007fc53e"]])

export default __exports__